// Atalhos de teclado do BALCÃO (pedido do dono, 29/09/2026): Enter = Finalizar
// e Avançar, Esc = Adicionar mais, F3/F4 = Comer no Local / Para Viagem (Tab
// alterna, Enter confirma). Cada tela passa o seu mapa { tecla: ação }.
//
// O leitor de código de barras também manda Enter, mas colado numa rajada de
// teclas (< 80 ms entre elas, o mesmo limite de hooks/useLeitorCodigoBarras):
// esse Enter é do leitor e não vale como atalho. Com popup aberto (produto,
// pizza, avisos) nenhum atalho age. A ação que devolve `false` não fez nada e
// deixa a tecla seguir o caminho normal.
import { useEffect, useRef } from "react";

const RAJADA_MS = 80;

export function useAtalhosBalcao(teclas, ativo = true) {
  const teclasRef = useRef(teclas);
  teclasRef.current = teclas;

  useEffect(() => {
    if (!ativo) return undefined;
    let ultimaTecla = -Infinity;
    // Fase de captura: registra até as teclas que o leitor segura.
    const registrar = (e) => { if (e.key && e.key.length === 1) ultimaTecla = e.timeStamp; };
    const agir = (e) => {
      if (e.defaultPrevented || e.repeat || e.ctrlKey || e.altKey || e.metaKey) return;
      const acao = teclasRef.current[e.key];
      if (!acao) return;
      if (e.key === "Enter" && e.timeStamp - ultimaTecla < RAJADA_MS) return;
      if (e.target?.tagName === "TEXTAREA") return;
      // Setas num campo de texto são do campo (cursor, lista da busca de cliente).
      if (e.key.startsWith("Arrow") && ["INPUT", "SELECT"].includes(e.target?.tagName)) return;
      // Tecla apertada dentro de uma janela (valor recebido, Dividir…) é da
      // janela — mesmo que ela já tenha fechado com essa tecla (Enter confirma
      // e fecha; sem isto o mesmo Enter ainda finalizaria o pedido).
      if (e.target?.closest?.('[role="dialog"], [role="alertdialog"]')) return;
      if (document.querySelector('[role="dialog"], [role="alertdialog"]')) return;
      if (acao(e) !== false) e.preventDefault();
    };
    window.addEventListener("keydown", registrar, true);
    window.addEventListener("keydown", agir);
    return () => {
      window.removeEventListener("keydown", registrar, true);
      window.removeEventListener("keydown", agir);
    };
  }, [ativo]);
}
